import React from 'react';

const BurgerIcon = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.125 15.5H16.875M3.125 5.5H16.875H3.125ZM3.125 10.5H16.875H3.125Z" stroke="#104665" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default BurgerIcon;
